module.exports = __webpack_public_path__ + "img/Investec.d9480e67.svg";